<template>
  <div class="stepper mt-5">
    <div
      class="stepper__step"
      v-for="(step, index) in steps"
      :key="`step-${index}`"
    >
      <span
        class="stepper__step-text"
        :class="{ active: currentStep >= index }"
        >{{ stepText[index] }}</span
      >
      <div
        :class="{ active: currentStep >= index }"
        class="stepper__step-badge"
      >
        <v-icon v-if="currentStep > index" color="white" small
          >mdi-check</v-icon
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    steps: {
      type: Number,
      default: 3,
    },
    currentStep: {
      type: Number,
      default: 3,
    },
    stepText: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin stepper-line {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: #c4c4c4;
  height: 3px;
  width: 100%;
  z-index: -1;
}

.stepper {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(1px, 1fr));
  justify-items: center;
  position: relative;
  z-index: 5;
  &__step {
    display: flex;
    width: 100%;
    justify-content: center;
    position: relative;
    &-text {
      position: absolute;
      top: -2em;
      &.active {
        color: #3d2892;
      }
    }
    &-badge {
      display: flex;
      justify-content: center;
      width: 25px;
      height: 25px;
      line-height: 40px;
      border-radius: 50%;
      font-size: 50px;
      color: #fff;
      border: 4px solid #c4c4c4;
      background-color: #eeeeee;
      box-sizing: content-box;
      &:before {
        @include stepper-line();
        left: -50%;
      }
      &.active {
        background: #3d2892;
        box-shadow: 0 0 0 3px #3d2892;
        border: 3px solid #eeeeee;
        &:before {
          background: #3d2892;
        }
      }
    }
    &:nth-last-child(1) {
      .stepper__step-badge {
        &::after {
          @include stepper-line();
          width: 50%;
          right: 0;
        }
        &.active {
          &::after {
            background: #3d2892;
          }
        }
      }
    }
    &:first-child {
      .stepper__step-badge {
        &::before {
          width: 50%;
          left: 0;
          background: #3d2892;
        }
      }
    }
  }
}
</style>
